import AutocompleteSearch from './autocomplete-search';

// AutocompleteSearch class is intended to be used as a single
// instance that can be accessed globally throughout the site
// More info on the singleton design pattern here:
// https://www.freecodecamp.org/news/singleton-design-pattern-with-javascript/#pros-and-cons-of-the-singleton-design-pattern
export default new AutocompleteSearch();
